import React from 'react';

export const DefaultCard = () => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_7846_183010)">
      <path
        d="M4.43227 6.66797H36.0989C38.4001 6.66797 40.2655 8.53344 40.2655 10.8346V29.168C40.2655 31.4691 38.4001 33.3346 36.0989 33.3346H4.43227C2.13109 33.3347 0.265625 31.4692 0.265625 29.168V10.8347C0.265625 8.53344 2.13109 6.66797 4.43227 6.66797Z"
        fill="#D1D5DB"
      />
      <path
        d="M0.265625 11.668H40.2656V18.3346H0.265625V11.668Z"
        fill="#9CA3AF"
      />
      <path
        d="M12.7656 24.9988H6.09898C5.63875 24.9988 5.26562 24.6256 5.26562 24.1654C5.26562 23.7052 5.63875 23.332 6.09898 23.332H12.7656C13.2259 23.332 13.599 23.7052 13.599 24.1654C13.599 24.6256 13.2259 24.9988 12.7656 24.9988ZM17.7656 28.3321H6.09898C5.63875 28.3321 5.26562 27.959 5.26562 27.4988C5.26562 27.0385 5.63875 26.6654 6.09898 26.6654H17.7656C18.2259 26.6654 18.599 27.0385 18.599 27.4988C18.599 27.959 18.2259 28.3321 17.7656 28.3321Z"
        fill="#FAFAFA"
      />
      <path
        d="M31.4399 25.8513C31.4399 26.0243 31.3712 26.1901 31.2489 26.3124C31.1266 26.4347 30.9607 26.5035 30.7877 26.5035H30.7008C30.5295 26.5008 30.3662 26.431 30.2461 26.3089C30.1259 26.1869 30.0586 26.0225 30.0586 25.8513C30.0586 25.6801 30.1259 25.5157 30.2461 25.3937C30.3662 25.2716 30.5295 25.2018 30.7008 25.1991H30.7877C30.9607 25.1991 31.1266 25.2679 31.2489 25.3902C31.3712 25.5125 31.4399 25.6783 31.4399 25.8513ZM32.8538 23.7824C32.7042 23.6975 32.5272 23.6751 32.3612 23.7201C32.1952 23.7651 32.0536 23.8739 31.9674 24.0227C31.8812 24.1715 31.8573 24.3484 31.9008 24.5148C31.9443 24.6812 32.0518 24.8236 32.1999 24.9111C32.5356 25.1057 32.7443 25.4659 32.7443 25.8514C32.7443 26.2368 32.5358 26.5971 32.1999 26.7916C32.0757 26.8636 31.9788 26.9745 31.924 27.1072C31.8693 27.2399 31.8598 27.3869 31.8971 27.5255C31.9344 27.6641 32.0164 27.7866 32.1304 27.8739C32.2443 27.9611 32.3839 28.0084 32.5274 28.0083C32.6383 28.0083 32.7508 27.98 32.8537 27.9204C33.5907 27.4934 34.0485 26.7006 34.0485 25.8515C34.0485 25.0023 33.5908 24.2093 32.8538 23.7824ZM34.5926 22.2751C34.4429 22.1886 34.265 22.165 34.0979 22.2096C33.9308 22.2542 33.7882 22.3633 33.7015 22.5129C33.6586 22.5871 33.6307 22.6689 33.6195 22.7538C33.6082 22.8387 33.6138 22.925 33.6359 23.0078C33.6579 23.0905 33.6961 23.1681 33.7482 23.2361C33.8003 23.3041 33.8652 23.3612 33.9394 23.404C34.8114 23.9086 35.353 24.8463 35.353 25.8512C35.353 26.8561 34.8114 27.794 33.9394 28.2986C33.8653 28.3415 33.8004 28.3985 33.7483 28.4665C33.6962 28.5345 33.658 28.6121 33.636 28.6949C33.6139 28.7776 33.6083 28.8639 33.6196 28.9488C33.6308 29.0337 33.6587 29.1155 33.7016 29.1897C33.7445 29.2638 33.8015 29.3288 33.8695 29.3809C33.9375 29.4331 34.0151 29.4712 34.0979 29.4933C34.1807 29.5154 34.267 29.521 34.3519 29.5097C34.4368 29.4984 34.5187 29.4704 34.5928 29.4275C35.8663 28.6904 36.6574 27.3202 36.6574 25.8512C36.6574 24.3822 35.8662 23.0121 34.5926 22.2751Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_7846_183010">
        <rect
          width="40"
          height="40"
          fill="white"
          transform="translate(0.265625)"
        />
      </clipPath>
    </defs>
  </svg>
);
